import { createAsyncThunk } from '@reduxjs/toolkit';
import { AccountRepositoryImpl } from '../Data/repositories/AccountRepositoryImpl';
import { CreateAccountUseCase } from '../Domain/UseCase/CreateAccountUseCase';
import { GetAccountsUseCase } from '../Domain/UseCase/GetAccountsUseCase';
import { UpdateAccountUseCase } from '../Domain/UseCase/UpdateAccountUseCase';
import { DeleteAccountUseCase } from '../Domain/UseCase/DeleteAccountUseCase';
import { ResetPasswordUseCase } from '../Domain/UseCase/ResetPasswordUseCase';
import { CreateAccountDTO } from '../Domain/Repositories/AccountRepository';
import { DeleteAccountsUseCase } from '../Domain/UseCase/DeleteAccountsUseCase';
import { isAxiosError } from 'axios';
import { User } from '../../User/Model/User';

const repo = new AccountRepositoryImpl();

export const fetchAccounts = createAsyncThunk('account/fetchAll', () => {
  return new GetAccountsUseCase(repo).execute();
});

export const addAccount = createAsyncThunk(
  'account/create',
  async (payload: CreateAccountDTO, { rejectWithValue }) => {
    const result = await new CreateAccountUseCase(repo).execute(payload);
    if (result.isOk()) return result.value;
    return rejectWithValue(result.error);
  },
);

export const editAccount = createAsyncThunk(
  'account/update',
  async (args: { id: number; dto: Partial<CreateAccountDTO>; me: User }, { rejectWithValue }) => {
    const result = await new UpdateAccountUseCase(repo).execute(args.id, args.dto, args.me);
    if (result.isOk()) return result.value;
    return rejectWithValue(result.error);
  },
);

export const removeAccount = createAsyncThunk(
  'account/delete',
  async (id: number, { rejectWithValue }) => {
    const result = await new DeleteAccountUseCase(repo).execute(id);
    if (result.isOk()) return id;
    return rejectWithValue(result.error);
  },
);

export const removeAccountMany = createAsyncThunk(
  'account/deleteMany',
  (ids: number[]) => new DeleteAccountsUseCase(repo).execute(ids),
);

export const resetPassword = createAsyncThunk(
  'account/resetPassword',
  async (args: { id: number; newPassword: string }, { rejectWithValue }) => {
    const result = await new ResetPasswordUseCase(repo).execute(args.id, args.newPassword);
    if (result.isOk()) return args.id;
    return rejectWithValue(result.error);
  },
);